// extracted by mini-css-extract-plugin
export default {"benefit-list-wrapper":"oaYh1","title":"JQ3VK","benefit-wrapper":"aElrw"};